import { FC } from 'react';

type Props = {
	className?: string;
};

const PackageIconDuotone: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			fill='none'>
			<path
				opacity='0.4'
				d='M17.2009 14.1291C17.2009 15.2351 15.6444 15.8927 12.5314 17.2077C11.2807 17.736 10.6554 18.0001 10.0009 18.0001C9.34629 18.0001 8.721 17.736 7.47037 17.2077C4.35731 15.8927 2.80078 15.2351 2.80078 14.1291V6L10.0009 9.48387L17.2009 6V14.1291Z'
				fill='#2B2B2B'
			/>
			<path
				d='M10.0009 18.0001C9.34629 18.0001 8.721 17.736 7.47037 17.2077C4.35731 15.8927 2.80078 15.2351 2.80078 14.1291C2.80078 13.8194 2.80078 8.45162 2.80078 6M10.0009 18.0001C10.6554 18.0001 11.2807 17.736 12.5314 17.2077C15.6444 15.8927 17.2009 15.2351 17.2009 14.1291V6M10.0009 18.0001V9.48387'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.06156 8.15316L4.72458 7.02233C3.44204 6.40172 2.80078 6.09142 2.80078 5.60004C2.80078 5.10865 3.44204 4.79835 4.72458 4.17774L7.06156 3.04691C8.50388 2.34897 9.22508 2 10.0009 2C10.7766 2 11.4978 2.34896 12.9402 3.04691L15.2771 4.17774C16.5596 4.79835 17.2009 5.10865 17.2009 5.60004C17.2009 6.09142 16.5596 6.40172 15.2771 7.02233L12.9402 8.15316C11.4978 8.85111 10.7766 9.20007 10.0009 9.20007C9.22508 9.20007 8.50388 8.85111 7.06156 8.15316Z'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M5.19922 10L6.79923 10.8'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.0001 3.6001L6 7.60014'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default PackageIconDuotone;
